import { aiInRecruitingIntegrationSectionData } from 'constants/AiInRecruiting'
import styles from './AiInRecruitingIntegrationSection.module.css'

const AiInRecruitingIntegrationSection = () => {
  const { title, subtitle, items } = aiInRecruitingIntegrationSectionData

  return (
    <section className={styles.integrationSection}>
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-12 col-lg-5">
            <h2 className={styles.sectionTitle}>{title}</h2>
            <p className={styles.sectionSubtitle}>{subtitle}</p>
          </div>

          <div className="col-12 col-lg-6">
            <div className={styles.list}>
              {items.map((item, i) => (
                <div key={i} className={styles.card}>
                  <h3 className={styles.cardLabel}>{item.label}</h3>{' '}
                  <p className={styles.cardText}>{item.tools}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AiInRecruitingIntegrationSection
